module.exports = __webpack_public_path__ + "static/SQUARE_dock-boat-874bd6c51a740da494ef97d44dbe7962.jpeg";